import { Box, FormControlLabel, Typography, Checkbox, Radio, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplayIcon from "@mui/icons-material/Replay";

const OptionRow = ({
    option,
    variant,
    isChecked = false,
    handleChange,
    isMulti,
    isLast,

    // nuove props
    mode = "client",
    isDeleted = false,
    onToggleDelete,
}) => {

    const isOwner = mode === "owner";

    const control = isMulti ? (
        <Checkbox
            checked={isChecked}
            onChange={e => handleChange?.(e, variant)}
            value={option.id}
            sx={{ display: isOwner && isDeleted ? "none" : "inline-flex" }}
        />
    ) : (
        <Radio
            value={option.id}
            sx={{ display: isOwner && isDeleted ? "none" : "inline-flex" }}
        />
    );

    return (
        <Box
            sx={{
                borderBottom: isLast ? "none" : "1px solid rgba(56,56,56,0.3)",
                paddingY: 0.5,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                transition: "background-color 0.1s",
                "&:hover": {
                    backgroundColor: "rgba(56,56,56,0.15)",
                },
                borderRadius: 1,
            }}
        >
            <FormControlLabel
                value={option.id}
                control={control}
                label={
                    <Typography
                        variant="body1"
                        sx={{
                            textTransform: "capitalize",
                            fontWeight: isChecked ? "bold" : "normal",
                            textDecoration: isOwner && isDeleted ? "line-through" : "none",
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                        }}
                    >
                        {option.label}

                        {/* Prezzo INLINE solo per OWNER */}
                        {isOwner && option.price > 0 && (
                            <Typography
                                variant="overline"
                                sx={{ color: "text.secondary", lineHeight: 1 }}
                            >
                                +{option.price.toFixed(2).replace(".", ",")} €
                            </Typography>
                        )}
                    </Typography>
                }
                sx={{ marginRight: 0 }}
            />

            {/* PARTE DESTRA */}
            {!isOwner ? (
                // CLIENT → prezzo a destra (come prima)
                <Typography
                    variant="subtitle2"
                    sx={{
                        fontWeight: "bold",
                        color: "text.secondary",
                        whiteSpace: "nowrap",
                        marginLeft: 1,
                    }}
                >
                    +{option.price.toFixed(2).replace(".", ",")} €
                </Typography>
            ) : (
                // OWNER → Delete / Replay
                <IconButton
                    size="small"
                    onClick={() => onToggleDelete?.(variant.id, option.id)}
                >
                    {isDeleted ? (
                        <ReplayIcon fontSize="small" color="primary" />
                    ) : (
                        <DeleteIcon fontSize="small" color="secondary" />
                    )}
                </IconButton>
            )}
        </Box>
    );
};

export default OptionRow;
